import React from 'react';
import PropTypes from 'prop-types';
import LoginContainer from './LoginContainer';
import LoginStatic from './LoginStatic';

const LoginStaticContainer = ({
	onLoginSuccess,
	onBeforeSocialLogin,
	contextUsage,
	onGuestCheckoutSelected,
	...props
}) => (
	<LoginContainer onLoginSuccess={onLoginSuccess} onBeforeSocialLogin={onBeforeSocialLogin} contextUsage={contextUsage} onGuestCheckoutSelected={onGuestCheckoutSelected}>
		{sharedProps => <LoginStatic {...sharedProps} {...props} />}
	</LoginContainer>
);

// Props are passed here from backbone, checkout_login_view.js
LoginStaticContainer.propTypes = {
	onLoginSuccess: PropTypes.func,
	onBeforeSocialLogin: PropTypes.func,
	contextUsage: PropTypes.string,
	onGuestCheckoutSelected: PropTypes.func,
	isCheckout: PropTypes.bool,
};

export default LoginStaticContainer;
